import React from "react"
import { Button, Col, FormGroup, Input, InputGroup, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import { cloneDeep } from "lodash"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"

const ProductUnit = (props: any) => {
    const { data, setData, type, onlyView, unit, setUnit, branch, validation, onValidation } = props

    const handleUnitAdd = () => {
        const newDetailtiveUser = {
            name: "",
            quantity_conversion:"",
        };
        setUnit([...unit, newDetailtiveUser]);
    };

    const handleUnitUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(unit);
        newDetailtiveUser[index] = dataDetail;
        setUnit(newDetailtiveUser);
        const stockValidation = {
            ...validation?.unit
        }
        if(!stockValidation[index]) stockValidation[index] = {}
        const item = dataDetail
        stockValidation[index].quantity_conversion = stockValidation[index].name = ''

        if(item?.name && !item?.quantity_conversion) stockValidation[index].quantity_conversion = 'Giá trị không được để trống!'
        if(!item?.name && item?.quantity_conversion) stockValidation[index].name = 'Tên đơn vị không được để trống!'
        onValidation({
            ...validation,
            unit: stockValidation
        })
    };

    const handleUnitRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(unit);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser = [{
            name: "",
            quantity_conversion:"",
        }]
        setUnit(newDetailtiveUser);
    };

    return (
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Quy đổi đơn vị</div>
                <ToggleButton isDisabled={type == 'view' ? true: false} elmChecked={data?.unit_status == 1 ? true : false} data={data} setData={(data:any) => {setData(data)}} name='unit_status' />
            </div>
            {data?.unit_status == 1 &&
                unit?.map((item:any, index:number) => (
                    <UnitItem 
                        detailIndex={index} 
                        data={item}
                        onChangeData={(dataDetail: any) =>
                            handleUnitUpdate(dataDetail, index)
                        }
                        validation={validation && validation.unit && validation.unit[index]}
                        type={type}
                        onlyView={onlyView}
                        handleRemoveData={() => handleUnitRemove(index)}
                        handleAddData={() => handleUnitAdd()}
                        detail={unit}
                    />
                ))
            }
        </PageBody>
    )
}

const UnitItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData, validation} = props
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }
    
    return (
        <Row key={detailIndex}>
            <Col md={6} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Tên đơn vị</Label>
                    <InputGroup>
                        <Input type="text" value={data?.name} onChange={(e: any) => handleChangeData(e)} name="name" placeholder="Nhập tên đơn vị..." />
                        {validation?.name &&<div className="invalid-feedback d-block" >{validation?.name}</div>}
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col md={5} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Số lượng quy đổi</Label>
                    <NumberFormat 
                        onChange={(e: any) => handleChangeData({ target: { name: 'quantity_conversion', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'quantity_conversion'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.quantity_conversion ? '---': data?.quantity_conversion}
                        placeholder={(type=='view' && !data?.quantity_conversion) ? "---" : "Nhập số lượng quy đổi..."} thousandSeparator={true} 
                    />
                    {validation?.quantity_conversion &&<div className="invalid-feedback d-block" >{validation?.quantity_conversion}</div>}
                </FormGroup>
            </Col>
            {!onlyView &&
            <Col md={1} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label></Label>
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                    {
                        detail?.length == detailIndex+1 &&
                        <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>
                    }
                </FormGroup>
            </Col>}
        </Row>
    )
}

export default ProductUnit